import React from "react";
import { Query } from "react-contentful";
import GeneralError from "../components/GeneralError";

const withContentfulTag = (
  WrappedComponent,
  contentfulTag,
  contentType = "General"
) => {
  const HOC = (props) => (
    <Query
      contentType={contentType}
      query={{
        "fields.tag": contentfulTag,
      }}
    >
      {({ data, error, fetched, loading }) => {
        if (loading || !fetched) {
          return (
            <div className="flex justify-center text-center p-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
                />
              </svg>
            </div>
          );
        }
        let decoratedProps = {
          contentfulTag,
          contentType,
          contentful: !!data?.items ? data?.items[0]?.fields : undefined,
          metadata: !!data?.items ? data?.items[0]?.metadata : undefined,
          sys: !!data?.items ? data?.items[0]?.sys : undefined,
          error,
          fetched,
          loading,
        };
        return fetched && !error && data?.items?.length ? (
          <WrappedComponent {...props} {...decoratedProps} />
        ) : (
          <GeneralError
            contentfulTag={contentfulTag}
            contentType={contentType}
            error={error}
          />
        );
      }}
    </Query>
  );
  return HOC;
};

export default withContentfulTag;
